if (!customElements.get('dlux-variant-quick-add-modal')) {
  customElements.define(
    'dlux-variant-quick-add-modal',
    class DluxVariantQuickAddModal extends ModalDialog {
      constructor() {
        super();

        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.addButton = this.querySelector('[data-dlux-variant-add]');
        this.cancelButton = this.querySelector('[data-dlux-variant-cancel]');
        this.errorEl = this.querySelector('[data-dlux-variant-error]');

        if (this.addButton) {
          this.addButton.addEventListener('click', this.onAdd.bind(this));
        }
        if (this.cancelButton) {
          this.cancelButton.addEventListener('click', () => this.hide());
        }

        this.querySelectorAll('.dlux-variant-quick-add-modal__radio').forEach((input) => {
          input.addEventListener('change', () => this.clearError());
        });
      }

      clearError() {
        if (!this.errorEl) return;
        this.errorEl.textContent = '';
        this.errorEl.classList.add('hidden');
      }

      onAdd() {
        if (!this.cart || !this.addButton) return;
        if (this.addButton.getAttribute('aria-disabled') === 'true') return;

        const selected = this.querySelector('.dlux-variant-quick-add-modal__radio:checked');
        if (!selected || selected.disabled || selected.dataset.variantAvailable === 'false') {
          if (this.errorEl) {
            this.errorEl.textContent =
              (window.variantStrings && window.variantStrings.unavailable) || 'Choose an available option.';
            this.errorEl.classList.remove('hidden');
          }
          return;
        }

        this.clearError();

        const spinner = this.addButton.querySelector('.loading__spinner');

        this.addButton.setAttribute('aria-disabled', 'true');
        this.addButton.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');

        this.cart.setActiveElement(this.openedBy || this.addButton);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', selected.value);
        formData.append('quantity', '1');
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'dlux-variant-quick-add',
                productVariantId: selected.value,
                errors: response.errors || response.description,
                message: response.message,
              });
              if (this.errorEl) {
                this.errorEl.textContent = response.description || response.message || '';
                this.errorEl.classList.remove('hidden');
              }
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'dlux-variant-quick-add',
              productVariantId: selected.value,
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
            });

            this.hide();
            CartPerformance.measure('add:paint-updated-sections', () => {
              this.cart.renderContents(response);
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.addButton.classList.remove('loading');
            this.addButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
